import { helper } from '@ember/component/helper';

/**
 * Helper to get a split value from a result's splitsMap
 * The splitsMap is keyed by courseElementUuid (not intermediateTimingPointUuid)
 * because multiple course elements can reference the same timing point in lap races.
 *
 * Usage: {{get-split result courseElementUuid "elapsedFormatted"}}
 */
export default helper(function getSplit([result, courseElementUuid, field = 'elapsedFormatted']) {
  if (!result || !result.splitsMap || !courseElementUuid) {
    return '—';
  }

  const split = result.splitsMap[courseElementUuid];
  if (!split) {
    return '—';
  }

  const value = split[field];
  return value !== null && value !== undefined ? value : '—';
});
